import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { PermissionService } from '@services/permission.service';
import { NormalDoctorPermission, RocheDoctorPermission } from 'src/app/_constants/permissions';

export const PermissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);
  const requiredPermissions = route.data?.['permissions'] as string[];
  const isAssistantAllowed = route.data?.['isAssistant'] as boolean;
  const isAssistant = permissionService.isAssistant();
  const fallback = getFallbackRoute(permissionService);

  // Case 1: No permissions required (public route)
  if (!requiredPermissions?.length) {
    // Block assistants from non-assistant-allowed routes
    if (isAssistant && !isAssistantAllowed) {
      return fallback === null ? false : router.parseUrl(fallback);
    }
    return true;
  }

  // Case 2: Permissions required
  // Grant access if user has any required permission OR is an allowed assistant
  const hasRequiredPermission = requiredPermissions.some(permission =>
    permissionService.hasPermission(permission)
  );

  if (hasRequiredPermission || (isAssistant && isAssistantAllowed)) {
    return true;
  }

  // No access - redirect to fallback, or failing that, prevent nagivation.
  return fallback === null ? false : router.parseUrl(fallback);
};

// Helper function to determine fallback route
export function getFallbackRoute(permissionService: PermissionService): string | null {
  if (permissionService.hasPermission(RocheDoctorPermission)) {
    return '/roche-psp';
  }

  if (permissionService.isAssistant()) {
    return '/patientList';
  }

  if (permissionService.hasPermission(NormalDoctorPermission)) {
    return '/home';
  }

  return null;
}